module.exports = __webpack_public_path__ + "img/img1.8d6de61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/02/img1.png
// module id = 185
// module chunks = 0